/* eslint frontbucket-patterns/no-new-emotion-styled: "warn" */
import styled from '@emotion/styled';

import { borderRadius, colors, gridSize } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';

export const FilterContainer = styled.div`
  margin: 0 0 ${gridSize() * 2}px 0;
`;

export const BranchActionsWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
`;

export const BranchPaginationWrapper = styled.div`
  & > div {
    margin-top: ${gridSize() * 4}px;
    margin-bottom: ${gridSize() * 8}px;
  }
`;

// Apply 32px margin top to all but the first child within the wrapper
export const CommentThreadWrapper = styled.div`
  border: 1px solid ${token('color.border', colors.N30)};
  border-radius: ${borderRadius()}px;
  flex: auto;
  margin: -${gridSize()}px;
  padding: ${gridSize()}px;
  max-width: 960px;
  & > * + * {
    margin-top: ${token('space.400', '32px')};
  }
`;
